import React from 'react';
import { FormField, inputClass } from './FormField';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../../common/SafeIcon';

const emptyChild = () => ({ name: '', dob: '', relationship: '' });

export const StepMinorChildren = ({ formData, onChange, errors }) => {
  const children = formData.children || [emptyChild()];

  const updateChild = (index, field, value) => {
    const updated = children.map((c, i) => i === index ? { ...c, [field]: value } : c);
    onChange({ ...formData, children: updated });
  };

  const addChild = () => {
    if (children.length < 4) onChange({ ...formData, children: [...children, emptyChild()] });
  };

  const removeChild = (index) => {
    onChange({ ...formData, children: children.filter((_, i) => i !== index) });
  };

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-lg font-semibold text-brand-navy mb-1">Minor Children</h3>
        <p className="text-sm text-slate-500">Add up to 4 children who will be covered by this Power of Attorney.</p>
      </div>

      {errors.children && (
        <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">{errors.children}</p>
      )}

      <div className="space-y-4">
        {children.map((child, index) => (
          <div key={index} className="border border-slate-200 rounded-lg p-4 bg-slate-50 relative">
            <div className="flex justify-between items-center mb-3">
              <span className="text-sm font-semibold text-brand-navy">Child {index + 1}</span>
              {children.length > 1 && (
                <button
                  type="button"
                  onClick={() => removeChild(index)}
                  className="text-red-400 hover:text-red-600 transition-colors"
                >
                  <SafeIcon icon={FiIcons.FiTrash2} className="text-sm" />
                </button>
              )}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              <FormField label="Full Name" error={errors[`child_${index}_name`]} required>
                <input
                  type="text"
                  className={inputClass(errors[`child_${index}_name`])}
                  value={child.name}
                  onChange={(e) => updateChild(index, 'name', e.target.value)}
                  placeholder="Child's full name"
                />
              </FormField>
              <FormField label="Date of Birth" error={errors[`child_${index}_dob`]} required>
                <input
                  type="date"
                  className={inputClass(errors[`child_${index}_dob`])}
                  value={child.dob}
                  onChange={(e) => updateChild(index, 'dob', e.target.value)}
                />
              </FormField>
              <FormField label="Relationship" error={errors[`child_${index}_relationship`]} required>
                <input
                  type="text"
                  className={inputClass(errors[`child_${index}_relationship`])}
                  value={child.relationship}
                  onChange={(e) => updateChild(index, 'relationship', e.target.value)}
                  placeholder="e.g. Son, Daughter"
                />
              </FormField>
            </div>
          </div>
        ))}
      </div>

      {children.length < 4 && (
        <button
          type="button"
          onClick={addChild}
          className="flex items-center gap-2 text-sm text-brand-navy font-medium border border-dashed border-slate-300 rounded-lg px-4 py-3 w-full justify-center hover:bg-slate-50 transition-colors"
        >
          <SafeIcon icon={FiIcons.FiPlus} /> Add Another Child
        </button>
      )}
    </div>
  );
};